import { Component, Input, inject } from '@angular/core';
import { AbstractControl, ControlContainer, FormControl, FormGroupDirective } from '@angular/forms';
import { distinctUntilChanged } from 'rxjs';
import { SubSink } from 'SubSink';

@Component({
  selector: 'app-date-range-filter',
  templateUrl: './date-range-filter.component.html',
  styleUrl: './date-range-filter.component.scss',
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
  standalone: false
})
export class DateRangeFilterComponent {
  formGroupDirective = inject(FormGroupDirective);

  @Input() name: Array<string>;
  @Input() label?: string;
  @Input() placeholder?: string;
  @Input() changeCallback: (startDate: string, endDate: string) => void;
  @Input() description?: string;

  private readonly subs = new SubSink();

  constructor() { }

  get startRangeName() {
    return this.name[0];
  }

  get endRangeName() {
    return this.name[1];
  }

  private get startControl(): AbstractControl {
    return this.formGroupDirective.form.get(this.startRangeName);
  }
  private get endControl(): AbstractControl {
    return this.formGroupDirective.form.get(this.endRangeName);
  }

  ngOnInit(): void {
    this.addControl();

    if (this.changeCallback) {
      this.subs.sink = this.startControl.valueChanges.pipe(distinctUntilChanged()).subscribe(() => this.emitChanges());
      this.subs.sink = this.endControl.valueChanges.pipe(distinctUntilChanged()).subscribe(() => this.emitChanges());
    }
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
    this.removeControl();
  }

  private emitChanges(): void {
    if (this.changeCallback) {
      this.changeCallback(this.startControl.value, this.endControl.value);
    }
  }

  private addControl(): void {
    this.formGroupDirective.form.addControl(this.startRangeName, new FormControl(null), { emitEvent: false });
    this.formGroupDirective.form.addControl(this.endRangeName, new FormControl(null), { emitEvent: false });
  }

  private removeControl(): void {
    this.formGroupDirective.form.removeControl(this.startRangeName, { emitEvent: false });
    this.formGroupDirective.form.removeControl(this.endRangeName, { emitEvent: false });
  }
}
